{
  "label": "group of users",
  "button": {
    "delete": "Remove the group",
    "create": "New group"
  },
  "confirmDelete": {
    "title": "Group removal",
    "description": "The selected group \"{userGroupName}\" will be removed"
  },
  "cannotDelete": {
    "title": "Group removal cannot be done",
    "description": "The selected group \"{userGroupName}\" is associated with {usersCount} users"
  },
  "empty": "No groups found",
  "search": "Search by name",
  "create": {
    "title": "New group",
    "confirm": {
      "title": "Group creation"
    }
  },
  "update": {
    "title": "Modify group",
    "confirm": {
      "title": "Edit the group"
    }
  },
  "confirm": {
    "message": "Do you confirm cancelling the operation? All unsaved data will be lost."
  },
  "information": "Group information",
  "name": "Group name",
  "sector": {
    "title": "Sectors"
  },
  "sectors": {
    "label": "Sectors attached to the group"
  },
  "addUsers": {
    "title": "Add users"
  }
}
